class SizeGuideGender extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.currentGender = 'men'
    this.setGender(this.currentGender)
  }

  setupListeners () {
    super.setupListeners()

    this.els.button.elements.forEach((buttonEl) => {
      this.listeners.add(buttonEl, 'click', this.onButtonClick.bind(this))
    })
  }

  onButtonClick (event) {
    const buttonEl = event.currentTarget
    const gender = buttonEl.dataset.sizeGuideGenderValue

    if (!gender) return

    this.setGender(gender)
  }

  setGender (gender) {
    this.currentGender = gender

    this.updateButtons()
    this.updateGuides()
  }

  updateButtons () {
    this.els.button.elements.forEach((buttonEl) => {
      const isActive =
        buttonEl.dataset.sizeGuideGenderValue === this.currentGender

      buttonEl.setAttribute('aria-pressed', isActive ? 'true' : 'false')

      if (isActive) {
        buttonEl.classList.replace('btn-Button-light', 'btn-Button-dark')
        return
      }

      buttonEl.classList.replace('btn-Button-dark', 'btn-Button-light')
    })
  }

  updateGuides () {
    this.els.guide.elements.forEach((guideEl) => {
      const isActive =
        guideEl.dataset.sizeGuideGenderValue === this.currentGender

      guideEl.setAttribute('aria-hidden', isActive ? 'false' : 'true')
      guideEl.hidden = !isActive
    })
  }
}

if (!customElements.get('size-guide-gender')) {
  customElements.define('size-guide-gender', SizeGuideGender)
}
